import { render, staticRenderFns } from "./RelTurma.vue?vue&type=template&id=6c067d8b"
import script from "./RelTurma.vue?vue&type=script&lang=js"
export * from "./RelTurma.vue?vue&type=script&lang=js"
import style0 from "./RelTurma.vue?vue&type=style&index=0&id=6c067d8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports